import styles from './BeforeAwaitingTable.module.scss';
import cn from 'classnames';
import { BeforeProps } from '@containers/DataTable';
import { ErrorResponse } from '@api/Responses/ErrorResponse';
import {
  getApproachingDeadline,
  TApproachingDeadlineResponse,
  TAwaitingParcel
} from '@api/apiClient/returns';
import { Text, TextSize } from '@components/Text';
import { Trans, useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

const BeforeAwaitingTable = ({ isLoading }: BeforeProps<TAwaitingParcel>) => {
  const { t } = useTranslation();

  const {
    data: dataGetApproachingDeadline,
    isFetching: isFetchingGetApproachingDeadline
  } = useQuery<TApproachingDeadlineResponse, ErrorResponse>({
    queryKey: ['getApproachingDeadline', 'returnsAwaiting'],
    queryFn: getApproachingDeadline,
    retry: 1
  });

  if (!isLoading && !isFetchingGetApproachingDeadline) {
    if (dataGetApproachingDeadline && dataGetApproachingDeadline.count) {
      return (
          <div className={cn(styles.inner, styles.innerRed)}>
            <Text size={TextSize.M}>
              <b className={cn(styles.text, styles.textRed)}>
                {t('returnsPage.awaitingTab.notyReturnsTitle')}
              </b>
            </Text>
            <Text size={TextSize.M}>
              <span className={cn(styles.text, styles.textRed)}>
                <b>
                  {dataGetApproachingDeadline.count}
                </b>{' '}-{' '}
                <Trans i18nKey="returnsPage.awaitingTab.notyReturnsText"/>
              </span>
            </Text>
          </div>
      );
    }
  }
  return null;
};

export default BeforeAwaitingTable;
